import { env } from '@/env'
import { api } from '@/services/fintalk/api'

export interface Bot {
  _id: string
  active: boolean
  name: string
  company_id: string
  description: string
  picture?: string
  created_at: Date
  updated_at: Date
  published_at?: Date
}

export async function listCompanyBots(companyId: string): Promise<Bot[]> {
  const resp = await api.get<Bot[]>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    `/company/${companyId}/bots`,
  )

  return resp.body
}
